export const REQUIRED_COLUMNS = [
  "courseId",
  "vid",
  "lesson",
  "scheduledTeacher",
  "classDetails",
  "abbr",
  "from",
  "to",
  "teacherId",
  "location"
];
export const DEFAULT_COLUMNS = [
  ...REQUIRED_COLUMNS,
  "startAt",
  "location",
  "status",
  "statusBy",
  "statusMessage",
];

export const ALL_COLUMNS = [
  {
    key: "courseId",
    title: "Course ID",
  },
  {
    key: "vid",
    title: "VID",
  },
  {
    key: "classDetails",
    title: "Class Details",
  },
  {
    key: "abbr",
    title: "Abbr",
  },
  {
    key: "from",
    title: "Published At",
  },
  {
    key: "lesson",
    title: "Lesson",
  },

  {
    key: "teacherId",
    title: "Teacher ID",
  },
  {
    key: "scheduledTeacher",
    title: "Teacher Name",
  },
  {
    key: "location",
    title: "Location",
  },
 
  {
    key: "status",
    title: "Status",
  },
  {
    key: "statusBy",
    title: "By",
  },
  {
    key: "statusMessage",
    title: "Reason",
  },
  {
    key: "startAt",
    title: "Actual Start",
  },
  {
    key: "to",
    title: "Actual End",
  },
  {
    key: "startBy",
    title: "Start By",
  },
  {
    key: "remark",
    title: "Remark",
  },
  {
    key: "kgs-studio",
    title: "KGS",
  },
  {
    key: "youtube",
    title: "Yt",
  },
  {
    key: "web",
    title: "Public",
  },
];
